"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ChevronDownMedium;
var _ChevronDownMedium = require("@adobe/react-spectrum-ui/dist/ChevronDownMedium.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function ChevronDownMedium(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_ChevronDownMedium.ChevronDownMedium, null));
}